import { useState } from 'react';

import * as S from './styles';

import { useAuth } from '../../hooks/auth';

import Header from '../../components/Header';

import Menu from '../../components/Menu';

import Modal from '../../components/Modal';

import { useTranslation } from 'react-i18next';

export default function Dashboard() {

	const [modalShow, setModalShow] = useState<boolean>(false);
	const [shortcode, setShortcode] = useState<string>('');
	const [uri, setUri] = useState<string>('');

	const { profile } = useAuth();

	const { t } = useTranslation();

	function handleModalLikes(shortcode: string, uri: string) {

		setShortcode(shortcode);
		setUri(uri);
		setModalShow(true);
	}

	return (
		<S.Container>

			< Header model='full' />

			<S.Notice>
				<p>AVISO IMPORTANTE: Estamos enfrentando uma instabilidade temporária em nossos serviços. Nossa equipe já está trabalhando para resolver o problema o mais rápido possível. Assim que tudo for normalizado, realizaremos todas as reposições necessárias de forma automática.</p>
				<br />
				<p>Pedimos desculpas pelo transtorno!</p>
				<br />
				<p>Qualquer dúvida, entre em contato com nosso suporte.</p>
			</S.Notice>

			<S.Content>

				{!profile.profile && (
					<S.NoProfile>
						<h2>{t('selectAProfile')}</h2>
					</S.NoProfile>
				)}

				<S.ContentPosts>
					{profile.posts && profile.posts.map(post => (
						<button key={post.shortcode} onClick={() => handleModalLikes(post.shortcode, post.uri)}>
							<S.Post key={post.shortcode} src={post.uri} />
						</button>
					))}
				</S.ContentPosts>
			</S.Content>

			<Modal
				modalShow={modalShow}
				modalHide={() => {
					setModalShow(false);
					setShortcode('');
					setUri('');
				}}
				shortcode={shortcode}
				uri={uri}
			>
			</Modal>

			<Menu />
		</S.Container >
	);
}